var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      { staticClass: "modal-dialog-scrollable modal-dialog modal-xl" },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.options1, function (option) {
                return _c(
                  "div",
                  { key: option.title, staticClass: "col-md col-12" },
                  [
                    _c("div", { staticClass: "card" }, [
                      _c("img", {
                        staticClass: "card-img-top",
                        attrs: { alt: option.title, src: option.img },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("button", {
                          staticClass: "btn btn-block sgp-btn-default",
                          domProps: { innerHTML: _vm._s(option.text) },
                          on: {
                            click: function ($event) {
                              return _vm.onSelect(option)
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.options2, function (option) {
                return _c(
                  "div",
                  { key: option.title, staticClass: "col-md col-12" },
                  [
                    _c("div", { staticClass: "card" }, [
                      _c("img", {
                        staticClass: "card-img-top",
                        attrs: { alt: option.title, src: option.img },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("button", {
                          staticClass: "btn btn-block sgp-btn-default",
                          domProps: { innerHTML: _vm._s(option.text) },
                          on: {
                            click: function ($event) {
                              return _vm.onSelect(option)
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                attrs: { type: "button" },
                on: { click: _vm.onCancel },
              },
              [_vm._v("\n                    Cancel\n                ")]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }